<grid [control]="control" [add]="addTarefa.bind(this)" [disabled]="disabled ? 'true' : undefined" [minHeight]="50" [hasEdit]="false" [hasDelete]="false" [editable]="editable ? 'true' : undefined">
  <columns>
    <column [title]="lex.translate('Tipo de Tarefa') + ' e Descrição'" [template]="tipoTarefaDescricao">
      <ng-template let-row="row" #tipoTarefaDescricao>
        <strong *ngIf="row.tipo_tarefa?.nome?.length" class="d-block">{{row.tipo_tarefa?.nome || ""}}</strong>
        <text-html [html]="row.descricao || ''" [analiser]="editorService.bindProfileClick.bind(editorService)"></text-html>
      </ng-template>
    </column>
    <!--<column type="timer" title="Tempo estimado" onlyHours field="tempo_estimado"></column>-->
<!--     <column *ngIf="consolidacao" title="Documento" [template]="documento">
      <ng-template let-row="row" #documento>
        <documentos-badge [documento]="row.documento"></documentos-badge>
      </ng-template>
    </column> -->
    @if(withComments){
      <column title="Informações adicionais" [template]="tarefaComentarios">
        <ng-template let-row="row" #tarefaComentarios>
          <comentarios-widget [entity]="row" [noPersist]="isPersist ? undefined : 'true'" [selectable]="selectable" origem="ATIVIDADE_TAREFA" [grid]="grid" [save]="addComentarioResult.bind(this)"></comentarios-widget>
        </ng-template>
      </column>
    } @else {
      <column [maxWidth]="250" [template]="columnComments">
        <ng-template let-row="row" #columnComments align="right">
          <documentos-badge [documento]="row.documento"></documentos-badge>
          <badge [icon]="'bi bi-chat-left-quote'" hint="Ver/Incluir comentários" color="warning" (click)="onComentariosClick(row)" role="button">{{ row?.comentarios?.length?.toString() || "0" }}</badge>
        </ng-template>
      </column>
    }
    <column *ngIf="consolidacao" title="Concluído" [align]="'center'" [template]="concluido" [columnEditTemplate]="editConcluido" [canEdit]="canConcluidoEdit.bind(this)" [edit]="editable ? onColumnConcluidoEdit.bind(this) : undefined" [save]="editable ? onColumnConcluidoSave.bind(this) : undefined">
      <ng-template let-row="row" #concluido>
        <div class="text-center"><i *ngIf="row.data_conclusao" class="bi bi-check-circle"></i></div>
      </ng-template>
      <ng-template let-row="row" #editConcluido>
        <input-switch [size]="12" controlName="concluido" [control]="formEdit!.controls.concluido"></input-switch>
      </ng-template>
    </column>
    <column *ngIf="editable && !selectable && !id_processo && !acompanhamento" type="options" [dynamicButtons]="dynamicButtons.bind(this)"></column>
  </columns>
</grid>